import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../api/axios";
import "../../styles/theme-dark.css";
import ConfigInformeInstalacion from "./ConfigInformeInstalacion";
import RellenarInformeInstalacion from "./RellenarInformeInstalacion";

// "editor" | "informe"




// ============================
// MINI ESTADO REUTILIZABLE
// ============================
function MiniEstadoEnvio({
  preparado,
  enviado,
  onToggle,
  textoPendiente = "No enviado",
  textoMarcar = "Marcar para enviar",
  textoFinal = "Enviado",
}) {
  let color = "rgba(231,76,60,0.75)";
  let texto = textoPendiente;

  if (preparado && !enviado) {
    color = "rgba(241,196,15,0.85)";
    texto = textoMarcar;
  }

  if (preparado && enviado) {
    color = "rgba(46,204,113,0.85)";
    texto = textoFinal;
  }

  


  return (
    <div
      onClick={preparado ? onToggle : undefined}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        cursor: preparado ? "pointer" : "default",
      }}
      title={texto}
    >
      <div
        style={{
          width: 14,
          height: 14,
          borderRadius: 3,
          border: "1px solid rgba(255,255,255,0.35)",
          background: color,
          boxShadow: "0 0 0 2px rgba(0,0,0,0.15) inset",
        }}
      />
      <span style={{ fontSize: 12, opacity: 0.85 }}>
        {texto}
      </span>
    </div>
  );
}


/* API BASE (para imágenes) */
const API_BASE =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://panel.corex3.com";

/* ============================
   ESTILO LIGERO
============================ */
const card = {
  padding: "12px 14px",
  borderRadius: 10,
  background: "rgba(255,255,255,0.03)",
  border: "1px solid rgba(255,255,255,0.08)",
  marginBottom: 12,
};

const input = {
  height: 30,
  borderRadius: 6,
  border: "1px solid rgba(255,255,255,0.15)",
  background: "rgba(255,255,255,0.06)",
  padding: "0 8px",
  color: "#fff",
  fontSize: 13,
  width: "100%",
};

const label = {
  fontSize: 12,
  marginBottom: 3,
  opacity: 0.8,
};

const smallBtn = {
  padding: "6px 10px",
  fontSize: 12,
  borderRadius: 6,
  cursor: "pointer",
  background: "rgba(255,255,255,0.08)",
  border: "1px solid rgba(255,255,255,0.15)",
  color: "#fff",
};

/* ============================
   MODAL GENERICO
============================ */
function Modal({ open, onClose, title, children }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 3000,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.65)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
      }}
    >
      <div style={{ ...card, width: 420, maxHeight: "85vh", overflow: "auto" }}>
        <h3 style={{ marginBottom: 12 }}>{title}</h3>
        {children}
        <button style={{ ...smallBtn, marginTop: 10 }} onClick={onClose}>
          Cerrar
        </button>
      </div>
    </div>
  );
}

/* ============================
   EDITOR INFORME
============================ */
export default function EditorInforme() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [vista, setVista] = useState("editor");

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [imagenGrande, setImagenGrande] = useState(null);


  const [instChecklist, setInstChecklist] = useState(null);
  const [loadingChecklist, setLoadingChecklist] = useState(true);

  const estadoInforme = instChecklist?.estado || "borrador";

const bloqueado =
  estadoInforme === "enviado" || estadoInforme === "firmado";


  console.log("EDITOR INFORME RENDER");

  const [data, setData] = useState({
    clienteNombre: "",
    direccionEnvio: "",
    nombre_referencia: "",
    contactoNombre: "",
    contactoTelefono: "",
    contactoEmail: "",
    fotosLugar: [],
    nombre_operario: "",
    telefono_operario: "",
    fecha_envio: "",
    obs_envio: "",
    informe_envio: "",
    fotos_pre_envio: [],
    fecha_instalacion: "",
    tecnico: "",
    obs_instalacion: "",
    fotos_instalacion: [],
    estado_envio_manual: false,
    estado_instalacion_manual: false,
    notas_internas: "",
    observaciones_cliente: "",
  });

  const inputLugarRef = useRef(null);
  const inputEnvioRef = useRef(null);
  const inputInstRef = useRef(null);

  // ✅ Cargar checklist (para que F5 no vuelva a "Configurar")
  useEffect(() => {
    async function cargarChecklist() {
      try {
        const res = await axios.get(`/checklists/instalacion/${id}`);

        // Aceptamos varias formas por compatibilidad:
        const checklist = res.data?.checklist || res.data?.data || res.data || null;

        if (checklist && checklist.id) {
          setInstChecklist(checklist);
        } else {
          setInstChecklist(null);
        }
} catch (e) {
  if (e.response?.status === 404) {
    // ✅ No hay checklist todavía → estado válido
    setInstChecklist(null);
  } else {
    console.error("Error cargando checklist:", e);
  }
} finally {
  setLoadingChecklist(false);
}

    }

    cargarChecklist();
  }, [id]);

  //useEffect(() => {
  //if (!loadingChecklist && instChecklist) {
  //  setVista("rellenar");
  //}
//}, [loadingChecklist, instChecklist]);


useEffect(() => {
  async function load() {
    try {
      const res = await axios.get(`/instalaciones/${id}`);
      const d = res.data || {};
   

      // ✅ AQUI ES DONDE VA
      const cliente = d.presupuesto?.cliente || {};

      setData({
        estado_envio_manual: d.estado_envio === "enviado",
        estado_instalacion_manual: d.estado_instalacion === "instalado",

        clienteNombre:
          d.clienteNombre ||
          cliente.nombre_empresa ||
          cliente.nombre ||
          "",

        direccionEnvio:
          d.direccionEnvio ||
          cliente.direccion_entrega ||
          cliente.direccion ||
          "",

        nombre_referencia: d.nombre_referencia || "",


        contactoNombre:
          cliente.personaContacto || "",

        contactoTelefono:
          cliente.telefono || "",

        contactoEmail:
          cliente.email || "",

        fecha_envio: d.fecha_envio ? String(d.fecha_envio).split("T")[0] : "",
        obs_envio: d.obs_envio || "",

        fecha_instalacion: d.fecha_instalacion
          ? String(d.fecha_instalacion).split("T")[0]
          : "",
        tecnico: d.tecnico || "",
        obs_instalacion: d.obs_instalacion || "",

        checklist: d.checklist || [],
        nombre_operario: d.nombre_operario || "",
        telefono_operario: d.telefono_operario || "",

        notas_internas: d.notas_internas ?? d.obs_internas ?? "",
        observaciones_cliente: d.observaciones_cliente ?? d.obs_cliente ?? "",

        fotosLugar: d.fotosLugar || [],
        fotos_pre_envio: d.fotos_pre_envio || [],
        fotos_instalacion: d.fotos_instalacion || [],
      });
    } catch (err) {
      console.error("Error cargando informe:", err);
    } finally {
      setLoading(false);
    }
  }

  load();
}, [id]);

async function handleEnviarFirma() {
  try {
    const ok = window.confirm(
      "Se enviará la instalación al cliente para su firma.\n\n¿Deseas continuar?"
    );
    if (!ok) return;

    const res = await axios.post(`/instalaciones/${id}/enviar-firma`);
    

    if (res.data?.success) {
      // 🔒 CIERRE DURO DEL EDITOR
      navigate("/tecnicos", { replace: true });
      return;
    }

    alert("No se pudo enviar la instalación a firmar.");
  } catch (err) {
    console.error("Error enviando a firmar:", err);
    alert(
      err.response?.data?.error ||
      "Error enviando la instalación a firmar"
    );
  }
}





  async function guardar() {
    try {
      setSaving(true);

      const payload = {
        ...data,
        estado_envio: data.estado_envio_manual ? "enviado" : "pendiente",
        estado_instalacion: data.estado_instalacion_manual ? "instalado" : "pendiente",

        fecha_envio: data.fecha_envio ? new Date(data.fecha_envio).toISOString() : null,
        fecha_instalacion: data.fecha_instalacion
          ? new Date(data.fecha_instalacion).toISOString()
          : null,
      };

      // blindaje final contra campos antiguos
      delete payload.obs_internas;
      delete payload.obs_cliente;
      delete payload.transporte;
      delete payload.seguimiento;
      delete payload.hora_instalacion;

      await axios.put(`/instalaciones/${id}`, payload);
      alert("Guardado correctamente.");
    } catch (err) {
      console.error("Error guardando:", err);
      alert("Error guardando");
    } finally {
      setSaving(false);
    }
  }

  async function guardarYVolver() {
    await guardar();
    navigate("/tecnicos");
  }

  async function handleDeleteFoto(path, tipo) {
    try {
      await axios.delete(`/instalaciones/${id}/foto`, {
        data: { path },
      });

      setData((prev) => {
        const nuevo = { ...prev };
        if (tipo === "lugar") {
          nuevo.fotosLugar = (prev.fotosLugar || []).filter((p) => p !== path);
        } else if (tipo === "envio") {
          nuevo.fotos_pre_envio = (prev.fotos_pre_envio || []).filter((p) => p !== path);
        } else if (tipo === "instalacion") {
          nuevo.fotos_instalacion = (prev.fotos_instalacion || []).filter((p) => p !== path);
        }
        return nuevo;
      });
    } catch (err) {
      console.error("Error borrando foto:", err);
      alert("Error borrando foto");
    }
  }

  async function handleUploadFotos(files, tipo) {
    if (!files || files.length === 0) return;

    const formData = new FormData();
    for (const file of files) {
      formData.append("files", file);
    }

    try {
      const res = await axios.post(`/instalaciones/${id}/fotos-${tipo}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setData((prev) => ({
        ...prev,
        fotosLugar: tipo === "lugar" ? res.data.fotosLugar : prev.fotosLugar,
        fotos_pre_envio: tipo === "envio" ? res.data.fotos_pre_envio : prev.fotos_pre_envio,
        fotos_instalacion:
          tipo === "instalacion" ? res.data.fotos_instalacion : prev.fotos_instalacion,
      }));
    } catch (err) {
      console.error("Error subiendo fotos:", err);
      alert("Error subiendo fotos");
    }
  }

 

    

// ============================
// ESTADOS CALCULADOS
// ============================

// ENVÍO
const envioPreparado = (data.fotos_pre_envio?.length || 0) > 0;
const envioEnviado = data.estado_envio_manual === true;

// INSTALACIÓN
const instalacionPreparada =
  (data.fotos_instalacion?.length || 0) > 0;

const instalacionInstalada =
  data.estado_instalacion_manual === true;







    // ============================
// ESTADOS AUTOMÁTICOS (VISUAL)
// ============================
const envioOK = (data.fotos_pre_envio?.length || 0) > 0;
const instalacionOK = (data.fotos_instalacion?.length || 0) > 0;

// ============================
// MINI CHECK INLINE
// ============================
const MiniEstado = ({ ok, okText, koText }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <div
      title={ok ? okText : koText}
      style={{
        width: 14,
        height: 14,
        borderRadius: 3,
        border: "1px solid rgba(255,255,255,0.35)",
        background: ok
          ? "rgba(46,204,113,0.85)"
          : "rgba(231,76,60,0.75)",
        boxShadow: "0 0 0 2px rgba(0,0,0,0.15) inset",
      }}
    />
    <span style={{ fontSize: 12, opacity: 0.85 }}>
      {ok ? okText : koText}
    </span>
  </div>
);

// ============================
// CAMBIO DE VISTA – INFORME
// ============================

// 1️⃣ CONFIGURAR INFORME (SIEMPRE PRIMERO)
if (vista === "config") {
  return (
    <ConfigInformeInstalacion
      instalacionId={id}
      onGenerado={() => {
        // cuando el técnico pulsa "Generar instalación"
        setVista("rellenar");
      }}
      volver={() => setVista("editor")}
    />
  );
}

// 2️⃣ RELLENAR INFORME (DESPUÉS DE GENERAR)
if (vista === "rellenar") {
  return (
    <RellenarInformeInstalacion
      instalacionId={id}
      volver={() => setVista("editor")}
    />
  );
}



  return (
    <div className="page-dark" style={{ padding: 20 }}>
      {/* ENCABEZADO */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 18,
  }}
>
  <div style={{ fontSize: 18, fontWeight: 700 }}>COREX3</div>

  <div style={{ display: "flex", gap: 8 }}>
    <button
  className="glass-btn"
  onClick={guardarYVolver}
  disabled={saving}
>
  {saving ? "Guardando..." : "Guardar y volver"}
</button>


    <button
      className="glass-btn"
      onClick={() => navigate("/tecnicos")}
    >
      Cerrar sin guardar
    </button>
  </div>
</div>


{/* 3 COLUMNAS */}
<div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: 12,
  }}
>


  {/* ================= CLIENTE ================= */}
<div style={card}>
  <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  }}
>
  <h4 style={{ margin: 0 }}>Cliente</h4>

  <button
    type="button"
    style={{
      ...smallBtn,
      padding: "4px 10px",
      fontSize: 12,
    }}
    onClick={() => {
      window.open(
        `${axios.defaults.baseURL}/informes/ficha-tecnica/${id}`,
        "_blank"
      );
    }}
  >
    📄 PDF
  </button>
</div>


  <label style={label}>Nombre</label>
  <input
    style={input}
    value={data.clienteNombre || ""}
    disabled
  />

  <label style={label}>Dirección de entrega</label>
<textarea
  style={{
    ...input,
    minHeight: 70,
    padding: 8,
    resize: "vertical",
  }}
  value={data.direccionEnvio || ""}
  disabled
/>


  <label style={label}>Contacto (nombre)</label>
  <input
  style={input}
  value={data.contactoNombre || ""}
  disabled
/>


  <label style={label}>Contacto (teléfono)</label>
  <input
    style={input}
    value={data.contactoTelefono || ""}
    disabled
  />

  <label style={label}>Contacto (email)</label>
  <input
    style={input}
    value={data.contactoEmail || ""}
    disabled
  />

  <label style={label}>Nombre referencia</label>
<input
  style={input}
  value={data.nombre_referencia || ""}
  onChange={(e) =>
    setData({ ...data, nombre_referencia: e.target.value })
  }
/>

  <h4 style={{ marginTop: 14 }}>Operario</h4>

<label style={label}>Nombre operario</label>
<input
  style={input}
  value={data.nombre_operario || ""}
  onChange={(e) =>
    setData({ ...data, nombre_operario: e.target.value })
  }
/>

<label style={label}>Teléfono operario</label>
<input
  style={input}
  value={data.telefono_operario || ""}
  onChange={(e) =>
    setData({ ...data, telefono_operario: e.target.value })
  }
/>


  <button
    type="button"
    style={{ ...smallBtn, marginTop: 10 }}
    onClick={() => inputLugarRef.current?.click()}
  >
    📷 Fotos del lugar
  </button>

  <input
    ref={inputLugarRef}
    type="file"
    multiple
    accept="image/*"
    style={{ display: "none" }}
    onChange={(e) => handleUploadFotos(e.target.files, "lugar")}
  />

  {(data.fotosLugar || []).length > 0 && (
    <div
      style={{
        marginTop: 8,
        display: "flex",
        flexWrap: "wrap",
        gap: 4,
      }}
    >
      {data.fotosLugar.map((src) => (
        <div key={src} style={{ position: "relative" }}>
          <img
            src={`${API_BASE}/${src}`}
            alt=""
            onClick={() => setImagenGrande(`${API_BASE}/${src}`)}
            style={{
              width: 60,
              height: 60,
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
          <button
            type="button"
            onClick={() => handleDeleteFoto(src, "lugar")}
            style={{
              position: "absolute",
              top: -6,
              right: -6,
              ...smallBtn,
              padding: "0 4px",
              fontSize: 10,
            }}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  )}
</div>


{/* ================= ENVÍO ================= */}
<div style={card}>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 10,
    }}
  >
    <h4 style={{ margin: 0 }}>Envío</h4>

    <MiniEstadoEnvio
      preparado={envioPreparado}
      enviado={envioEnviado}
      onToggle={() => {
        if (!envioPreparado) return;
        setData((prev) => ({
          ...prev,
          estado_envio_manual: !prev.estado_envio_manual,
        }));
      }}
    />
  </div>

  <label style={label}>Fecha envío</label>
  <input
    type="date"
    style={input}
    value={data.fecha_envio || ""}
    onChange={(e) =>
      setData({ ...data, fecha_envio: e.target.value })
    }
  />

  <label style={label}>Observaciones</label>
  <textarea
    style={{
      ...input,
      minHeight: 90,
      padding: 8,
      resize: "vertical",
    }}
    value={data.obs_envio || ""}
    onChange={(e) =>
      setData({ ...data, obs_envio: e.target.value })
    }
  />

  <button
    type="button"
    style={{ ...smallBtn, marginTop: 10 }}
    onClick={() => inputEnvioRef.current?.click()}
  >
    📷 Fotos envío
  </button>

  <input
    ref={inputEnvioRef}
    type="file"
    multiple
    accept="image/*"
    style={{ display: "none" }}
    onChange={(e) =>
      handleUploadFotos(e.target.files, "envio")
    }
  />

  {(data.fotos_pre_envio || []).length > 0 && (
    <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 4 }}>
      {data.fotos_pre_envio.map((src) => (
        <div key={src} style={{ position: "relative" }}>
          <img
            src={`${API_BASE}/${src}`}
            alt=""
            onClick={() => setImagenGrande(`${API_BASE}/${src}`)}
            style={{
              width: 60,
              height: 60,
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
          <button
            type="button"
            onClick={() =>
              handleDeleteFoto(src, "envio")
            }
            style={{
              position: "absolute",
              top: -6,
              right: -6,
              ...smallBtn,
              padding: "0 4px",
              fontSize: 10,
            }}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  )}

  <div style={{ display: "flex", gap: 6, marginTop: 12 }}>
    <button
      style={smallBtn}
      type="button"
      onClick={async () => {
        try {
          const r = await axios.post(`/instalaciones/${id}/informe-envio`);
          if (r.data.success) {
            alert("Informe de envío generado correctamente.");
            setData((prev) => ({
              ...prev,
              informe_envio: r.data.archivo,
            }));
          }
        } catch {
          alert("Error generando informe de envío.");
        }
      }}
    >
      📄 Generar
    </button>

    <button
      style={smallBtn}
      type="button"
      onClick={() => {
        if (!data.informe_envio)
          return alert("Aún no hay PDF generado.");
        window.open(`/${data.informe_envio}`, "_blank");


      }}
    >
      ⬇ Descargar
    </button>

    <button
      style={smallBtn}
      type="button"
      onClick={() =>
        alert("Envío por email se activará más adelante.")
      }
    >
      ✉ Enviar
    </button>
  </div>
  
{/* ✅ INDICADOR PDF GENERADO */}
  {data.informe_envio && (
    <div
      style={{
        marginTop: 8,
        fontSize: 12,
        color: "#7CFC9A",
        display: "flex",
        alignItems: "center",
        gap: 6,
        opacity: 0.9,
      }}
    >
      ✅ Informe de envío generado
    </div>
  )}

</div>


{/* ================= INSTALACIÓN ================= */}
<div style={card}>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 10,
    }}
  >
    <h4 style={{ margin: 0 }}>Instalación</h4>

    <MiniEstadoEnvio
      preparado={instalacionPreparada}
      enviado={instalacionInstalada}
      textoPendiente="No instalada"
      textoMarcar="Marcar instalada"
      textoFinal="Instalada"
      onToggle={() => {
        if (!instalacionPreparada) return;
        setData((prev) => ({
          ...prev,
          estado_instalacion_manual: !prev.estado_instalacion_manual,
        }));
      }}
    />
  </div>

  
  <label style={label}>Fecha instalación</label>
  <input
    type="date"
    style={input}
    value={data.fecha_instalacion || ""}
    onChange={(e) =>
      setData({ ...data, fecha_instalacion: e.target.value })
    }
  />

  <label style={label}>Técnico</label>
  <input
    style={input}
    value={data.tecnico || ""}
    onChange={(e) =>
      setData({ ...data, tecnico: e.target.value })
    }
  />

  <label style={label}>Observaciones instalación INTERNAS</label>
  <textarea
    style={{
      ...input,
      minHeight: 90,
      padding: 8,
      resize: "vertical",
    }}
    value={data.obs_instalacion || ""}
    onChange={(e) =>
      setData({ ...data, obs_instalacion: e.target.value })
    }
  />

  <button
    type="button"
    style={{ ...smallBtn, marginTop: 10 }}
    onClick={() => inputInstRef.current?.click()}
  >
    📷 Fotos instalación
  </button>

  <input
    ref={inputInstRef}
    type="file"
    multiple
    accept="image/*"
    style={{ display: "none" }}
    onChange={(e) =>
      handleUploadFotos(e.target.files, "instalacion")
    }
  />

  

  {(data.fotos_instalacion || []).length > 0 && (
    <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 4 }}>
      {data.fotos_instalacion.map((src) => (
        <div key={src} style={{ position: "relative" }}>
          <img
            src={`${API_BASE}/${src}`}
            alt=""
            onClick={() => setImagenGrande(`${API_BASE}/${src}`)}
            style={{
              width: 60,
              height: 60,
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
          <button
            type="button"
            onClick={() =>
              handleDeleteFoto(src, "instalacion")
            }
            style={{
              position: "absolute",
              top: -6,
              right: -6,
              ...smallBtn,
              padding: "0 4px",
              fontSize: 10,
            }}
          >
            ✕
          </button>

          {imagenGrande && (
  <div
    onClick={() => setImagenGrande(null)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.85)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      cursor: "zoom-out",
    }}
  >
    <div style={{ position: "relative" }}>
      <img
        src={imagenGrande}
        alt=""
        style={{
          maxWidth: "90vw",
          maxHeight: "90vh",
          borderRadius: 12,
          boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
        }}
        onClick={(e) => e.stopPropagation()}
      />

      <button
        onClick={() => setImagenGrande(null)}
        style={{
          position: "absolute",
          top: -12,
          right: -12,
          background: "rgba(0,0,0,0.7)",
          border: "1px solid rgba(255,255,255,0.4)",
          color: "#fff",
          borderRadius: "50%",
          width: 28,
          height: 28,
          cursor: "pointer",
          fontSize: 14,
        }}
      >
        ✕
      </button>
    </div>
  </div>
)}

        </div>
      ))}
    </div>
  )}

<div
  style={{
    width: "100%",
    maxWidth: 520, // mismo ancho que observaciones
    marginTop: 12,
  }}
>
  {/* BOTONES */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 6,
    }}
  >
    {/* INFORME */}
    <button
      style={smallBtn}
      disabled={bloqueado}
      onClick={() => {
        if (!instChecklist) {
          setVista("config");
        } else {
          setVista("rellenar");
        }
      }}
    >
      📄 Informe instalación
    </button>

    {/* RESTABLECER (INLINE, COMO YA FUNCIONA) */}
    <button
      style={{
        ...smallBtn,
        background: "rgba(231,76,60,0.25)",
        border: "1px solid rgba(231,76,60,0.5)",
      }}
      type="button"
      onClick={async () => {
        const ok = window.confirm(
          "⚠️ Esto eliminará el informe de instalación y todos sus checks.\n\n¿Seguro que quieres continuar?"
        );
        if (!ok) return;

        try {
          await axios.delete(`/checklists/instalacion/${id}/reset`);

          setInstChecklist(null);
          setVista("editor");

          alert("Informe de instalación restablecido.");
        } catch (e) {
          console.error(e);
          alert("Error restableciendo el informe.");
        }
      }}
    >
      ♻️ Restablecer informe
    </button>
  </div>

  {/* ESTADO */}
  {estadoInforme === "enviado" && (
    <div
      style={{
        marginTop: 12,
        textAlign: "center",
        fontWeight: 600,
        color: "#facc15",
      }}
    >
      INFORME ENVIADO
    </div>
  )}

{estadoInforme === "firmado" && (
  <div
    style={{
      marginTop: 12,
      textAlign: "center",
      fontWeight: 600,
      color: "#22c55e",
    }}
  >
    INFORME FIRMADO

    {instChecklist?.pdfPath && (
      <div style={{ marginTop: 10 }}>
        <button
          style={{
            ...smallBtn,
            padding: "8px 16px",
            fontWeight: 500,
          }}
          onClick={() =>
  window.open(`${API_BASE}${instChecklist.pdfPath}`, "_blank")

}

        >
          📄 Ver informe firmado (PDF)
        </button>
      </div>
    )}
  </div>
)}

</div>


</div> {/* ← cierre INSTALACIÓN */}

</div>   {/* ← cierre 3 COLUMNAS */}

{/* OBSERVACIONES */}
<div style={{ ...card, marginTop: 12 }}>
  <h4>Observaciones internas</h4>
  <textarea
    style={{
      width: "100%",
      height: 90,
      borderRadius: 6,
      background: "rgba(255,255,255,0.06)",
      padding: 8,
      border: "1px solid rgba(255,255,255,0.15)",
      color: "#fff",
      fontSize: 13,
    }}
    value={data.notas_internas || ""}
    onChange={(e) =>
      setData({ ...data, notas_internas: e.target.value })
    }
  />

  <h4 style={{ marginTop: 14 }}>Observaciones cliente</h4>
  <textarea
    style={{
      width: "100%",
      height: 70,
      borderRadius: 6,
      background: "rgba(255,255,255,0.06)",
      padding: 8,
      border: "1px solid rgba(255,255,255,0.15)",
      color: "#fff",
      fontSize: 13,
    }}
    value={data.observaciones_cliente || ""}
    onChange={(e) =>
      setData({
        ...data,
        observaciones_cliente: e.target.value,
      })
    }
  />
</div>


    </div>
  );

}
